import { useMutation } from '@tanstack/react-query'

import { generateCustomBriefFromHtml } from '../api'

const useGenerateCustomBriefFromHtmlMutation = () => {
  return useMutation({ mutationFn: generateCustomBriefFromHtml })
}

export default useGenerateCustomBriefFromHtmlMutation
